<form  role="form" method="Post" #appForm="ngForm" (ngSubmit)="validateCode()">
    <div class="mb-3">
      <label class="control-label dark" for="otp" translate>Application Code</label>
      <input class="form-control" type="text" placeholder="validate application code" [(ngModel)]="app.voucherCode"  name="applicationCode" required />
    </div>
    <!-- <button routerLink="/admissions/application" class="btn btn-danger btn-block" type="button" translate>Validate Code</button> -->
    <button type="submit" [disabled]="!appForm.valid" class="btn btn-danger btn-block" translate>Validate Code</button>
</form>
<br />